export enum AssetFieldTypeEnum {
    AssetType = 'ASSET_TYPE',
    Sdg = 'SDG',
    Doi = 'DOI',
    Title = 'TITLE',
    Subtitle = 'SUBTITLE',
    Volume = 'VOLUME',
    Issue = 'ISSUE',
    Pages = 'PAGES',
    Abstract = 'ABSTRACT',
    Keywords = 'KEYWORDS',
    LocalField1 = 'LOCAL_FIELD1',
    LocalField2 = 'LOCAL_FIELD2',
    LocalField3 = 'LOCAL_FIELD3',
    LocalField4 = 'LOCAL_FIELD4',
    LocalField5 = 'LOCAL_FIELD5',
    LocalField6 = 'LOCAL_FIELD6',
    LocalField7 = 'LOCAL_FIELD7',
    LocalField8 = 'LOCAL_FIELD8',
    LocalField9 = 'LOCAL_FIELD9',
    LocalField10 = 'LOCAL_FIELD10',
    LocalField11 = 'LOCAL_FIELD11',
    LocalField12 = 'LOCAL_FIELD12',
    LocalField13 = 'LOCAL_FIELD13',
    LocalField14 = 'LOCAL_FIELD14',
    LocalField15 = 'LOCAL_FIELD15',
}

export type AssetFieldType =
    (typeof AssetFieldTypeEnum)[keyof typeof AssetFieldTypeEnum];

export const getAssetFieldTypeKey = (fieldTypeValue: AssetFieldType) =>
    Object.keys(AssetFieldTypeEnum).find(
        (key) => AssetFieldTypeEnum[key] === fieldTypeValue,
    );

export const isLocalField = (fieldTypeKey: AssetFieldType) =>
    [
        AssetFieldTypeEnum.LocalField1,
        AssetFieldTypeEnum.LocalField2,
        AssetFieldTypeEnum.LocalField3,
        AssetFieldTypeEnum.LocalField4,
        AssetFieldTypeEnum.LocalField5,
        AssetFieldTypeEnum.LocalField6,
        AssetFieldTypeEnum.LocalField7,
        AssetFieldTypeEnum.LocalField8,
        AssetFieldTypeEnum.LocalField9,
        AssetFieldTypeEnum.LocalField10,
        AssetFieldTypeEnum.LocalField11,
        AssetFieldTypeEnum.LocalField12,
        AssetFieldTypeEnum.LocalField13,
        AssetFieldTypeEnum.LocalField14,
        AssetFieldTypeEnum.LocalField15,
    ].includes(fieldTypeKey);
